<template>
  <div class="pager-container" v-if="pageNumber > 1">
    <a @click="handleclick(1)" href="javascript:;" :class="{ disabled: current === 1 }">|&lt;&lt;</a>
    <a @click="handleclick(current - 1)" href="javascript:;" :class="{ disabled: current === 1 }">&lt;&lt;</a>
    <a @click="handleclick(n)" href="javascript:;" v-for="(n, i) in numbers" :key="i" :class="{ active: n === current }">{{ n }}</a>
    <a @click="handleclick(current + 1)" href="javascript:;" :class="{ disabled: current === pageNumber }">&gt;&gt;</a>
    <a @click="handleclick(pageNumber)" href="javascript:;" :class="{ disabled: current === pageNumber }">&gt;&gt;|</a>
  </div>
</template>

<script>
export default {
  props: {
    current: {
      type: Number,
      default: 1,
    },
    total: {
      type: Number,
      default: 0,
    },
    limit: {
      type: Number,
      default: 10,
    },
    visiableNumber: {
      type: Number,
      default: 10,
    }
  },
  computed: {
    pageNumber() {
      return Math.ceil(this.total / this.limit);
    },
    visualmin() {
      let min = this.current - Math.floor(this.visiableNumber / 2);
      if (min < 1) {
        min = 1;
      }
      return min;
    },
    visualmax() {
      let max = this.visualmin + this.visiableNumber - 1;
      if (max > this.pageNumber) {
        max = this.pageNumber;
      }
      return max;
    },
    numbers() {
      let nums = [];
      for (let i = this.visualmin; i <= this.visualmax; i++) {
        nums.push(i);
      }
      return nums;
    }
  },
  methods: {
    handleclick(newPage) {
      if(newPage<1){
        newPage=1;
      }
      if(newPage>this.pageNumber){
        newPage=this.pageNumber;
      }
      if(newPage===this.current){
        return;
      }
      this.$emit("pageChange", newPage)
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../style/var.less";

.pager-container {
  display: flex;
  justify-content: center;
  margin: 20px 0;

  a {
    color: @primary;
    margin: 0 6px;


    &.disabled {
      color: @lightWords;
      cursor: not-allowed;
    }

    &.active {
      color: @words;
      font-weight: bold;
      cursor: text;
    }
  }
}
</style>